import { useCallback, useMemo } from 'react';
import { FormikHelpers } from 'formik';
import { message } from 'antd';

import { useService } from '@core/inversify-react';
import { GetTopupSettingsRepo, GetTopupSettingsRepoType, UpdateTopupSettingsRepo, UpdateTopupSettingsRepoType } from '../repos';
import { TopupSettingsDto, ITopupSettings } from '../dtos';
import { useQuery } from 'react-query';

export const useTopupSettings = () => {
  const getTopupSettingsRepo = useService<GetTopupSettingsRepo>(GetTopupSettingsRepoType);
  const updateTopupSettingsRepo = useService<UpdateTopupSettingsRepo>(UpdateTopupSettingsRepoType);

  const data = useQuery<ITopupSettings, Error, ITopupSettings, string[]>(
    ['settings', 'topup'],
    async () => {
      const result = await getTopupSettingsRepo.execute();

      if (result.status === 200) {
        return result.response;
      } else {
        throw new Error(result.response);
      }
    },
    {},
  );

  const initialValues = useMemo<TopupSettingsDto>(() => {
    return {
      usdBalanceEnabled: data.data?.usdBalanceEnabled || false,
      tryBalanceEnabled: data.data?.tryBalanceEnabled || false,
    };
  }, [data]);

  const onSubmit = useCallback(
    async (values: TopupSettingsDto, helpers: FormikHelpers<TopupSettingsDto>) => {
      helpers.setStatus(null);
      const result = await updateTopupSettingsRepo.execute(values);
      if (result.status === 200) {
        message.success('Əməliyyat müvəffəqiyyətlə başa çatdı.');
      } else if (result.status === 422) {
        helpers.setErrors(result.response);
      } else {
        message.error(result.response);
      }
    },
    [updateTopupSettingsRepo],
  );

  return { initialValues, onSubmit, isLoading: data.isLoading };
};
